/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable import/no-unresolved */
import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError, } from "rxjs";
import { AppRoutes } from "@utils/constants";
import { ErrorTexts } from "@utils/japaneseLabels";



export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const router = inject(Router);
  const token = localStorage.getItem("authToken");

  // Clone request with Authorization header if token exists
  const authReq = token
    ? req.clone({
      setHeaders: {
        Authorization: `${token}`,
      },
    })
    : req;

  return next(authReq).pipe(
    catchError((error: any) => {
      const message = error?.error?.message;

      if (message === "Your session has expired. Please log in again.") {
        alert(ErrorTexts["session_time_out"]);
      }

      if (error instanceof HttpErrorResponse && error.status === 401) {
        localStorage.clear();
        router.navigate([AppRoutes.LOGIN]);
      }

      return throwError(() => error);
    })
  );
  // return next(req);
};
